import { initializeI18n } from '@immopersian/common';

import en from './locales/en.json';
import fa from './locales/fa.json';
import de from './locales/de.json';

const coursesResources = {
  en: { translation: en },
  fa: { translation: fa },
  de: { translation: de },
};

initializeI18n(coursesResources);
